const FeaturedActor = [
  {
    Name: 'Zendaya Coleman',
    img: 'zendaya.jpg',
    description: 'Zendaya Maree Stoermer Coleman is an American actress and singer. She has received various accolades, including two Primetime Emmy Awards. Time magazine named her one of the 100 most influential people in the world on its annual list in 2022.',
  },
];

export default FeaturedActor;
